import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'Děkujeme za vaše hodnocení!',
  text: 'Můžeme něco zlepšit? Podělte se s námi o svůj názor.',
  form: {
    fields: [
      {
        type: 'textarea',
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Váš názor...'
      }
    ],
    submit: {
      label: 'Odeslat'
    }
  }
};
